import { IComponentController } from 'angular';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';

interface IPageRc0002 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    rciMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rciMultiOccurrence: IMultiOccurrence;
}

/* @ngInject */
export default function Rc0002Controller(
    ecranDetails: IEcranDetailsResourcesEntite,
    Formulaire: IFormulaireClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    $stateParams: any,
    Menu: IMenuClass,
    MenuItemAction: IMenuItemActionClass,
    FormulaireItem: IFormulaireItemClass) {

    const vm: IPageRc0002 = this;
    
    vm.monoOccurrenceOptions = {
        fonctions: {
            boutonDupliquer: false
        },
        cycleErrorReloadBlocs: ['rci'],
        infosMonetaires: {
            blocs: ['rci'],
            donnees:
                [
                    { nom: 'txmmntrec', libelle: 'LBL_TXMMNTREC' },
                    { nom: 'devtaucou', libelle: 'LBL_DEVTAUCOU' }
                ]
        },
        menus: [
            new MenuItemAction(
                'LBL_BTN_FORMULAIRE_CEN',
                'BOUFORCEN',
                () => ({}),
                {
                    iconButton: false,
                    icon: 'print',
                    fonction: 'BOUFORCEN',
                    secondaire: true,
                    formulaireConfirmationAction: {
                        lblTitre: 'LBL_BTN_FORMULAIRE_CEN',
                        lblConfirm: 'G_LBL_BTN_APPLIQUER',
                        largeurFormulaire: 30,
                        formulaire: new Formulaire([
                            new FormulaireItem('trlcodcen', { required: true })
                        ], {
                            largeurDefaut: 100
                        })
                    },
                    hidden: (data:any) => !(data.aut__nbrfor)
                }
            ),            
            new MenuItemAction(
                'LBL_BTN_FORMULAIRE_CEN',
                'BOUFORCEN',
                () => ({}),
                {
                    iconButton: false,
                    icon: 'print',
                    fonction: 'BOUFORCEN',
                    secondaire: true,
                    hidden: (data:any) => (data.aut__nbrfor)
                }
            )
        ],
        formulaire: new Formulaire('LBL_BLC_TXM', [
            new FormulaireItem('magcleint'),
            new FormulaireItem('tydcleint'),
            new FormulaireItem('txmflgpij'),
            new FormulaireItem('txmnumdoc'),
            new FormulaireItem('txmnumdocseq'),
            new FormulaireItem('ltrcod', { default: ecranDetails.valeurs.ltrcod}),
            new FormulaireItem('refcleint'),
            new FormulaireItem('txmnumref'),
            new FormulaireItem('doccleintref'),
            new FormulaireItem('peccleint'),
            new FormulaireItem('txmdat'),
            new FormulaireItem('txmdatreq'),
            new FormulaireItem('intcleintmag'),
            new FormulaireItem('intcleintreq'),
            new FormulaireItem('intcleintdem'),
            new FormulaireItem('txmdsc', { largeur: 100 }),
            new FormulaireItem('vectxmcat'),
            new FormulaireItem('dacatt')
        ], { largeurDefaut: 33.33 })
    };

    vm.rciMultiOccurrenceOptions = {
        bloc: 'rci',
        fonctions: {
            boutonDupliquer: false
        },
        actionsNouveaux: new Menu([
            new MenuItemAction(
                'LBL_ITEM_REFERENCE',
                'BOUCREREF',
                () => ({}),
                {
                    icon: '',
                    iconButton: false,
                    fonction: 'BOUCREREF',
                    formulaireConfirmationAction: {
                        lblTitre: 'LBL_ITEM_REFERENCE',
                        lblConfirm: 'G_LBL_BTN_APPLIQUER',
                        largeurFormulaire: 70,
                        formulaire: new Formulaire([
                            new FormulaireItem('rciligrefnew', { 
                                required: true,
                                resourceParams: () => ({ doccleint: $stateParams.id })
                            }),
                            new FormulaireItem('procoddsc', { readonly: true }),
                            new FormulaireItem('forcleintnew', { readonly: true }),
                            new FormulaireItem('rciprxuninew', { required: true }),
                            new FormulaireItem('rciqtefornew', { required: true }),
                            new FormulaireItemSautDeLigne(),
                            new FormulaireItem('vecrciremstonew'),
                            new FormulaireItem('rcicomnew', { largeur: 66.66 }),
                            new FormulaireItem('rciqterupnew'),
                            new FormulaireItem('rciqteruprecnew'),
                            new FormulaireItem('rciflgfernew', { default: 0 })
                        ], {
                            largeurDefaut: 33.33
                        })
                    },
                    successAction: () => {
                        vm.rciMultiOccurrence.fetchDataList();
                    }
                }
            ),  
            new MenuItemAction(
                'LBL_ITEM_NON_REFERENCE',
                'BOUCRENONREF',
                () => ({}),
                {
                    icon: '',
                    iconButton: false,
                    fonction: 'BOUCRENONREF',
                    formulaireConfirmationAction: {
                        lblTitre: 'LBL_ITEM_NON_REFERENCE',
                        lblConfirm: 'G_LBL_BTN_APPLIQUER',
                        largeurFormulaire: 70,
                        formulaire: new Formulaire([
                            new FormulaireItem('procleintnew', { 
                                required: true,
                                resourceParams: (data:any) => ({
                                    magcleint: data.$ancetre.magcleint
                                })
                            }),
                            new FormulaireItem('forcleintnew', { 
                                required: true,
                                resourceParams: (data:any) => ({
                                    procleint: data.procleintnew
                                })
                             }),
                            new FormulaireItem('rciprxuninew', { required: true }),
                            new FormulaireItem('rciqtefornew', { required: true, default: 0 }),
                            new FormulaireItem('vecrciremstonew'),
                            new FormulaireItem('rcicomnew'),
                            new FormulaireItem('rciqterupnew'),
                            new FormulaireItem('rciqteruprecnew')
                        ], {
                            largeurDefaut: 50
                        })
                    },
                    successAction: () => {
                        vm.rciMultiOccurrence.fetchDataList();
                    }
                }
            )                      
        ]),
        colonnesFixesGauche: [
            { nom: 'dailig', largeur: 100 }
        ],
        colonnesVisibles: [
            { nom: 'dainumcat', largeur: 130 },
            { nom: 'procod', largeur: 150 },
            { nom: 'prodsc', largeur: 230 },
            { nom: 'rciprxuni', largeur: 120 },
            { nom: 'rciqtefor', largeur: 120 },
            { nom: 'rciqtefac', largeur: 120 },
            { nom: 'rcimnttot', largeur: 120 },
            { nom: 'forcod', largeur: 140 },
            { nom: 'fordsc', largeur: 180 },
            { nom: 'vecrciremsto_dsc', largeur: 150 },
            { nom: 'rcicom', largeur: 200 },
            { nom: 'rciqterup', largeur: 120 },
            { nom: 'rciqteruprec', largeur: 120 }
        ],
        colonnesFixesDroite: [
            { nom: 'rciflgfer', largeur: 100 },
            { nom: 'rciflgmsg', largeur: 100 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('rciprxuni'),
            new FormulaireItem('rciqtefor'),
            new FormulaireItem('rciqte', { readonly: true }),
            new FormulaireItem('rciqterup'),
            new FormulaireItem('rciqteruprec'),
            new FormulaireItem('vecrciremsto'),
            new FormulaireItem('rcicom'),
            new FormulaireItem('rciflgfer')
        ])
    };
}
